// 홈 페이지 번역
export default {
  hero: {
    welcomeTo: 'Welcome to',
    churchName: 'Seongdong Jungang Church',
    subtitle: 'A place where faith, hope, and love come together',
    visitUs: 'Visit Us'
  },
  latestNews: {
    sectionLabel: 'Latest News',
    title: 'Stay Connected',
    readMore: 'Read More',
    viewAll: 'View All News'
  },
  gallery: {
    sectionLabel: 'Gallery',
    title: 'Moments of Faith'
  },
  worship: {
    sectionLabel: 'WORSHIP',
    title: 'Service Times',
    tableService: 'Service',
    tableTime: 'Time',
    tableLocation: 'Location',
    note: 'Service times and locations may change depending on church circumstances.',
    viewDetail: 'View Details'
  }
};
